<template>
  <v-badge
    :color="item.colors[0]"
    :content="getBadgeContent"
    :value="item.comingSoon || item.isTest ? 1 : 0"
    bottom
    class="mx-auto d-block"
    left
    offset-x="80"
    style="width: 100%; max-width: 468px; position: relative"
  >
    <v-card
      :class="{ flat: item.comingSoon }"
      :ripple="false"
      :style="item.comingSoon ? `opacity: .2;pointer-events: none` : ''"
      class="d-flex align-center cat-holder"
      flat
      height="98"
      @click="$router.push({ name: item.route }).catch(() => {})"
    >
      <div
        :style="{
          background: `linear-gradient(to bottom left, ${item.colors[0]}, ${item.colors[1]}, ${item.colors[2]})`,
        }"
        class="main-bg"
      ></div>

            <v-avatar class="grey lighten-2" size="56">
        <div class="d-flex align-center ma-0">
          
          <!-- حالت اول: اگر آیتم دارای نشان Pro باشد -->
          <v-badge
            v-if="item?.pro"
            overlap
            top
            color="transparent"
            offset-x="17"
            offset-y="5"
          >
            <template v-slot:badge>
              <v-icon :color="item.colors[0]" size="14">mdi-crown</v-icon>
            </template>

            <!-- نمایش عکس در حالت Pro -->
            <img 
              v-if="item.image" 
              :src="item.image" 
              style="width: 29px; height: 29px; object-fit: contain;" 
            />
            <!-- نمایش آیکون در حالت Pro -->
            <v-icon v-else :color="item.colors[0]" size="29">{{ item.icon }}</v-icon>
          </v-badge>

          <!-- حالت دوم: اگر آیتم معمولی باشد (بدون نشان Pro) -->
          <template v-else>
            <!-- نمایش عکس در حالت معمولی -->
            <img 
              v-if="item.image" 
              :src="item.image" 
              style="width: 36px; height: 36px; object-fit: contain;" 
            />
            <!-- نمایش آیکون در حالت معمولی -->
            <v-icon v-else :color="item.colors[0]" large>{{ item.icon }}</v-icon>
          </template>

        </div>
      </v-avatar>

      <v-card class="cat-content transparent pr-6" flat relative>
        <div v-if="!!item.topBade" class="cat-content--ribbon">
          <v-avatar :color="item.colors[0]" size="24">
            <v-icon color="white" small>{{ item.topBade.icon }}</v-icon>
          </v-avatar>
          <p :style="{ color: item.colors[0] }" class="my-0 mx-2">
            {{ item.topBade.text }}
          </p>
        </div>

        <v-card-title
          :style="{ color: item.colors[0] }"
          class="w-100 py-2 font-italic font-size-h2 font-weight-bold text-break"
          v-text="item.name"
        />
        <v-card-text
          v-if="item.subtitle"
          v-text="item.subtitle"
          class="pe-0 pe-md-4"
        />
      </v-card>
      <slot />
    </v-card>
  </v-badge>
</template>

<script>
export default {
  name: "catCard",

  props: {
    item: Object,
  },

  computed: {
    getBadgeContent() {
      return this.item.comingSoon
        ? this.$t("soon")
        : this.item.isTest
        ? this.item.testTxt ?? this.$t("beta_version")
        : 0;
    },
  },
};
</script>

<style scoped>
.cat-content--ribbon {
  position: absolute !important;
  top: 0;
  left: 12px;
  background-color: #fff;
  border-radius: 999px !important;
  word-break: break-word;
  padding: 2px;
  transform: translateY(calc(-65% - 12px)) translateX(-35%);
  text-rendering: optimizeSpeed;
  display: flex;
  align-items: center;
  box-shadow: -3px 3px 2px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.1);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.cat-content--ribbon >>> .v-avatar {
  position: relative;
  transition: all 0.2s ease-out;
}

.cat-content--ribbon:hover >>> .v-avatar {
  box-shadow: -3px 3px 2px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-3px);
}
</style>
